import { DEFAULTSTORE_ROUTE_NAME } from '@/libs/route-name'

export const defaultstoreRoute = () => {
  return {
    name: DEFAULTSTORE_ROUTE_NAME.DEFAULTSTORE,
    path: 'defaultstore',
    component: () => import('@/pages/defaultstore/index.vue'),
  }
}
